import { Stack, Text } from '@common/ui'
import React from 'react'

export type EntityLabelLinesProps = {
  primary: string
  secondary?: string
}

const EntityLabelLines = ({ primary, secondary }: EntityLabelLinesProps) => (
  <Stack gap={2} style={{ minWidth: 0 }}>
    <Text fw={600} size="sm" truncate>
      {primary}
    </Text>
    {secondary && (
      <Text size="xs" c="dimmed" truncate>
        {secondary}
      </Text>
    )}
  </Stack>
)

export default EntityLabelLines
